import React, { useEffect, useState } from 'react';
import TrendCard from '../TrendCard';
import PRChart from './PRChart';
import { getStudioNews } from '@op/services';
import { canRequest } from '../utils';
import { reviewsFormat } from '@op/utils/value';
import { useIntl } from 'umi';
import { addWithoutSingleData } from '@op/utils';


interface IProps {
  // 筛选器
  filter: any;
  // 竞品浮窗是否延时请求
  isDelay?: boolean;
  config?: {
    // 竞品浮窗是否延时请求
    isDelay: boolean;
    className: string;
    style: React.CSSProperties;
  };
};

export default function PR(props: IProps) {
  const { formatMessage } = useIntl();
  const { filter, isDelay, config } = props || {};
  const isDelayVal = isDelay ? isDelay : config?.isDelay;
  const { className, style } = config || {};

  const [newValue, setNewValue] = useState<
  Array<{ count: number; time: string; }>
  >([]);
  const [oldValue, setOldValue] = useState<
  Array<{ count: number; time: string; }>
  >([]);
  const [newInfo, setNewInfo] = useState({ sentiment: 0, count: 0 });
  const [loading, setLoading] = useState(false);

  function requestServerData() {
    setLoading(true);
    getStudioNews(filter)
      .then((data: any) => {
        const {
          list,
          old_timeline_of_end_time,
          old_timeline_of_start_time,
          old_timeline,
          timeline,
          timeline_of_end_time,
          timeline_of_start_time,
        } = data || {};

        const oldTimeline = addWithoutSingleData(
          old_timeline_of_start_time,
          old_timeline_of_end_time,
          filter.date_type,
          old_timeline,
          { count: 0 },
        );
        const newTimeline = addWithoutSingleData(
          timeline_of_start_time,
          timeline_of_end_time,
          filter.date_type,
          timeline,
          { count: 0 },
        );

        setNewValue(newTimeline);
        setOldValue(oldTimeline);
        setNewInfo(list || { sentiment: 0, count: 0 });
      }).catch(() => {})
      .finally(() => {
        setLoading(false);
      });
   
  }

  useEffect(() => {
    if (canRequest(filter)) {
      requestServerData();
    }
  }, [filter]);

  return (
    <div className={className} style={style}>
      <TrendCard
        loadingHeight={160}
        loading={loading}
        title={'PR'}
        className="dbh-trend-card--pr"
        moduleType="news"
        filter={filter}
        isDelay={isDelayVal}
      >
        <div className="dbh-studio-pr">
          <div className="dbh-studio-pr-header">
            <div className="dbh-studio-pr-th">
              {/* <span>{formatMessage({ id: 'Sentiment' })}</span> */}
              <span>{formatMessage({ id: 'Article' })}</span>
            </div>
            <div className="dbh-studio-pr-td">
              {/* <span>{sentimentFormat(newInfo.sentiment)}</span> */}
              <span>{reviewsFormat(newInfo.count)}</span>
            </div>
          </div>
          <div className="dbh-studio-body">
            <PRChart
              leftTitle={'Article'}
              valueKey="count"
              height={110}
              filter={filter}
              newValue={newValue}
              oldValue={oldValue}
              list={[
                {
                  name: 'Current period',
                  color: '#5086F3',
                },
                {
                  name: 'Previous period',
                  color: '#69D19C',
                },
              ]}
            ></PRChart>
          </div>
        </div>
      </TrendCard>
    </div>
  );
}
